module.exports = __webpack_public_path__ + "static/media/YM89_3.1619f4e0.jpg";